module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-scrollDiv', {
    staticClass: "task-info-wrap",
    class: {
      hasBtn: _vm.process_flag
    },
    on: {
      "scroll": function($event) {
        _vm.hide_change = !_vm.hide_change
      }
    }
  }, [_c('div', {
    staticClass: "mod-title border"
  }, [_vm._v(_vm._s(_vm.task_id == 0 ? "任务创建：" : "任务详情：")), (_vm.task_id == 0 || (_vm.detail_data.category_status == 10 && _vm.detail_data.start_status == 10)) ? _c('span', {
    staticClass: "tip"
  }, [_vm._v("红色标志为必填项")]) : _vm._e()]), _vm._v(" "), _c('detail-form', {
    attrs: {
      "name": 'task_detail',
      "hide": _vm.hide_change,
      "sub": _vm.sub_data,
      "read": _vm.read_judge,
      "detailData": _vm.detail_data
    },
    on: {
      "refresh": _vm.getDetailData,
      "openDoc": function($event) {
        _vm.$emit('openDoc')
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.task_id != 0),
      expression: "task_id != 0"
    }],
    staticClass: "mod-title border"
  }), _vm._v(" "), _c('div', {
    staticClass: "alone-func"
  }, [_c('transition', {
    attrs: {
      "name": "up"
    }
  }, [(_vm.task_id != 0) ? _c('div', {
    staticClass: "relation"
  }, [_c('div', {
    staticClass: "mod-title"
  }, [_vm._v("关联任务：")]), _vm._v(" "), _c('relation', {
    attrs: {
      "read": _vm.read_judge,
      "detailData": _vm.detail_data
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "up"
    }
  }, [(_vm.detail_data.category_status != undefined && !(_vm.detail_data.category_status == 10 && (_vm.detail_data.process_status == 101 || _vm.detail_data.process_status == 103))) ? _c('div', {
    staticClass: "remark"
  }, [_c('div', {
    staticClass: "mod-title"
  }, [_vm._v("任务备注：")]), _vm._v(" "), _c('remarks', {
    attrs: {
      "read": _vm.read_judge,
      "detailData": _vm.detail_data
    },
    on: {
      "openDoc": function($event) {
        _vm.$emit('openDoc')
      }
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('processBtn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.process_flag),
      expression: "process_flag"
    }],
    staticClass: "process-btns",
    attrs: {
      "buType": _vm.bu_type,
      "sub": _vm.sub_data,
      "detailData": _vm.detail_data
    },
    on: {
      "refresh": _vm.getDetailData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-31afdd15!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/task/detailTask/task-detail.vue
// module id = 721
// module chunks = 1